<div [ngClass]="{ 'service-container': showMenu }">
  <div class="submenu" *ngIf="showMenu">
    <app-submenu [serviceTabs]="serviceSubmenuTabs"></app-submenu>
  </div>
  <div class="service-content">
    <router-outlet></router-outlet>
  </div>
</div>
